import { CompassCardUI } from '@scale/compass-ui/types';
import {
  type EditWorkerSkillEntrySchemaType,
  type EditWorkerSkillEntryContext,
  EditWorkerSkillEntryCardShared,
  EDIT_WORKER_SKILL_ENTRY,
} from '@scale/genai-compass-shared/cards/edit_worker_skill_entry';
import EditWorkerSkillEntryCardComponent from './EditWorkerSkillEntryCardComponent';
import { faUserGear } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: EditWorkerSkillEntryContext = {
  cardType: EDIT_WORKER_SKILL_ENTRY,
  selectedColumnIdWithWorkerIds: '',
  skillEntries: [],
  removeAllSkills: false,
  overrideReason: '',
};

export const EditWorkerSkillEntryCardInfo: CompassCardUI<
  EditWorkerSkillEntrySchemaType,
  EditWorkerSkillEntryContext
> = {
  ...EditWorkerSkillEntryCardShared,
  title: 'Edit Worker Skill Entries',
  icon: 'edit',
  toolTip: 'Edit skill entries for selected workers.',
  defaultContext,
  ownerTeam: 'Growth',
  showOutput: true,
  legacyComponent: EditWorkerSkillEntryCardComponent,
  button: {
    icon: faUserGear,
  },
};
